import { render, staticRenderFns } from "./ArrivalCards.vue?vue&type=template&id=09089666&scoped=true"
import script from "./ArrivalCards.vue?vue&type=script&lang=js"
export * from "./ArrivalCards.vue?vue&type=script&lang=js"
import style0 from "./ArrivalCards.vue?vue&type=style&index=0&id=09089666&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09089666",
  null
  
)

export default component.exports